<template>
  <div 
    id="custom-form-container"
    :class="[{ small: titleSmallInterval, 'row-block': layoutType === 'flex' }, layoutType]"
    :style="{
      flex: {
        gap: gap
      },
      grid: {
        gridTemplateColumns: (new Array(groupCount)).fill('').map(() => '1fr').join(' '),
        gridGap: gap
      }
    }[layoutType]"
  >
    <div
      class="form-group"
      v-for="(form, index) in forms.filter(form => form.display ? form.display(result) : true)"
      :key="index"
      :class="{
        disabled: (form.disabled || (() => false))(result),
        reading: reading,
        'display-mode': displayMode || form.displayMode
      }"
      :style="{
        flex: form.width ? { flexBasis: form.width } : { flex: form.flex || 1 },
        grid: form.grid ? { gridColumn: 'span ' + form.grid } : {}
      }[layoutType]"
    >
      <div>
        <form v-if="display" :data-vv-scope="scope">
          <div v-if="form.type || form.title">
            <!-- <div class="label" v-if="form.title && !['boolean'].includes(form.type)"> -->
            <div class="label" v-if="form.title">
              <span class="title">{{ form.title }}</span>
              <span class="required" v-if="form.validate && form.validate.includes('required') && form.title !== '　'">{{ (form.requiredMsg || (() => '*'))(form) }}</span>
              <span class="description">{{ form.description }}</span>
              <span class="invisible">{{ form.invisible }}</span>
            </div>
            <!-- <div v-if="form.type === 'boolean'" class="label">
              <label :for="form.value" class="row-block" :class="{ diabled: (form.disabled || (() => false))(result) }" :style="{ cursor: 'pointer' }">
                <img :src="result[form.value] ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
                <input v-show="false" type="checkbox" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result)" v-model="result[form.value]" v-validate="form.validate" />
                <div :style="{ width: '10px' }"></div>
                <div>{{ form.title }}</div>
                <div :style="{ flex: 1 }"></div>
              </label>
            </div> -->
            <div v-if="form.type && result[form.value] !== undefined" class="options" :class="[form.type, { error: alerts[form.value] || errors.has(scope + '.' + form.value) || form.error }]" :style="form.optionWidth ? { width: form.optionWidth, flex: 1 } : { flex: 1 }">
              <template v-if="form.type === 'input'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="text" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result) || form.inputDisabled" :placeholder="(form.placeholder || (() => ''))(form)" :autocomplete="form.autocomplete || 'on'" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" @keydown.enter.prevent />
                </div>
              </template>
              <template v-if="form.type === 'datalist'">
                <div>
                  <input type="text" :id="form.value" :name="form.value" :list="form.value + '-list'" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" @keydown.enter.prevent />
                  <datalist :id="form.value + '-list'">
                    <option v-for="(option, index) in form.lists" :key="index" :value="option"></option>
                  </datalist>
                </div>
              </template>
              <template v-if="form.type === 'password'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="password" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :autocomplete="form.autocomplete || 'on'" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" @keydown.enter.prevent />
                </div>
              </template>
              <template v-if="form.type === 'textarea'">
                <div v-show="form.visible !== false" class="input-group">
                  <textarea :id="form.value" :name="form.value" :tabindex="form.tabindex" :rows="form.row" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-if="form.type === 'select'">
                <div v-show="form.visible !== false" class="input-group">
                  <select :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result)" :style="result[form.value] ? {} : { color: '#A9A9A9' }" v-model="result[form.value]" v-validate="form.validate">
                    <option v-if="form.placeholder" value="" disabled>{{ form.placeholder(form) }}</option>
                    <option v-for="(option, index) in form.options" :key="index" :value="option.value || ''" :disabled="option.disabled" :style="{ color: '#333333' }">{{ option.title }}</option>
                  </select>
                </div>
              </template>
              <template v-else-if="form.type === 'boolean'">
                <div v-show="form.visible !== false" class="input-group">
                  <!-- <label :for="form.value" :class="{ diabled: (form.disabled || (() => false))(result) }">
                    <input type="checkbox" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="(form.disabled || (() => false))(result)" v-model="result[form.value]" v-validate="form.validate" />
                  </label> -->
                  <switchButton
                    :disabled="(form.disabled || (() => false))(result)"
                    :checked="result[form.value]"
                    @input="c => result[form.value] = c"
                  ></switchButton>
                </div>
              </template>
              <template v-else-if="form.type === 'single'">
                <div v-show="form.visible !== false" v-for="(option, index) in form.options" :key="index">
                  <label :for="form.value + '-' + option.value" :class="{ diabled: (form.disabled || (() => false))(result) }">
                    <input type="radio" :id="form.value + '-' + option.value" :name="form.value" :value="option.value" :disabled="(form.disabled || (() => false))(result)" v-model="result[form.value]" v-validate="form.validate" />
                    <span>{{ option.title }}</span>
                  </label>
                </div>
              </template>
              <template v-else-if="form.type === 'multiple'">
                <div v-show="form.visible !== false" v-for="(option, index) in form.options" :key="index">
                  <label :for="form.value + '-' + option.value" :class="{ diabled: (form.disabled || (() => false))(result) || form.range && ((form.range[0] === (result[form.value] || []).length && result[form.value].includes(option.value)) || (form.range[1] === (result[form.value] || []).length && !result[form.value].includes(option.value))) }">
                    <input type="checkbox" :id="form.value + '-' + option.value" :name="form.value" :value="option.value" :disabled="(form.disabled || (() => false))(result) || (form.range && ((form.range[0] === (result[form.value] || []).length && result[form.value].includes(option.value)) || (form.range[1] === (result[form.value] || []).length && !result[form.value].includes(option.value))))" v-model="result[form.value]" v-validate="form.validate" />
                    <span>{{ option.title }}</span>
                  </label>
                </div>
              </template>
              <template v-else-if="form.type === 'number'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="number" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="form.inputWidth ? { width: form.inputWidth } : {}" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'date'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="date" :id="form.value" :name="form.value" :tabindex="form.tabindex" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : '9999-12-31'" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'time'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="time" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'datetime'">
                <div v-show="form.visible !== false" class="input-group">
                  <input type="datetime-local" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="(form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'file'">
                <div v-show="form.visible !== false">
                  <input type="file" v-show="false" :id="form.value" :name="form.value" :multiple="form.multiple" :accept="form.accept" :disabled="(form.disabled || (() => false))(result)" @change="e => e.target.files.length ? Array.from(e.target.files) : []" v-validate="form.validate" />
                  <button :tabindex="form.tabindex">
                    <span>{{ form.text || 'select' }}</span>
                    <label :for="form.value" :class="{ diabled: (form.disabled || (() => false))(result) }"></label>
                  </button>
                  <template v-if="!$scopedSlots[form.value]">
                    <div v-for="(file, index) in result[form.value] || []" :key="index">
                      <span>{{ file.name }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else-if="form.type === 'text'">
                <div v-show="form.visible !== false" class="input-group">
                  <span :class="{ noWrap: !form.wrap }" :title="result[form.value]" :style="form.style || {}">{{ result[form.value] || '--' }}</span>
                </div>
              </template>
              <div v-if="alerts[form.value] || errors.has(scope + '.' + form.value) || form.error" :class="(alerts[form.value] || { type: 'error' }).type" :style="form.inputWidth ? { left: (form.inputWidth.replace('px', '') - 25) + 'px' } : {}">
                <div>
                  <img
                    :src="{
                      error: require('../../assets/images/times-solid.svg'),
                      success: require('../../assets/images/check-solid.svg')
                    }[(alerts[form.value] || { type: 'error' }).type]"
                  >
                  <div v-if="!alerts[form.value] || alerts[form.value].msg" class="menu-container">
                    <div class="menu-block default-shadow">
                      <span v-if="alerts[form.value]">{{ alerts[form.value].msg }}</span>
                      <span v-else-if="errors.has(scope + '.' + form.value) || form.error">{{ (form.alert || (() => null))(form, errors.first(scope + '.' + form.value)) || (errors.first(scope + '.' + form.value) || form.error).replace(form.value, form.errorTitle || form.title) }}</span>
                    </div>
                    <span class="cursor-bor-cor"></span>
                    <span class="menu-bor-cor shadow-top"></span>
                    <span class="menu-bor-cor shadow-left"></span>
                    <span class="menu-bor-cor shadow-right"></span>
                    <span class="menu-bor-cor"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="$scopedSlots[form.value]" class="custom" :class="{ 'main-custom': !form.type && !form.title }">
            <slot :name="form.value" :data="result" :result="result[form.value]" :output="output[form.value]" :form="form"></slot>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import switchButton from './switchButton'

export default {
  components: {
    switchButton
  },
  props: {
    forms: {
      type: Array,
      required: true
    },
    init: {
      type: Object,
      default: () => ({})
    },
    alerts: {
      type: Object,
      default: () => ({})
    },
    scope: {
      type: String,
      default: () => 'form'
    },
    reading: {
      type: Boolean,
      default: () => false
    },
    displayMode: {
      type: Boolean,
      default: () => false
    },
    titleSmallInterval: {
      type: Boolean,
      default: () => false
    },
    // style
    layoutType: {
      type: String,
      default: () => 'flex'
    },
    groupCount: {
      type: Number,
      default: () => 4
    },
    gap: {
      type: String,
      default: () => '16px'
    }
  },
  data () {
    return {
      result: {},
      output: {},
      display: true
    }
  },
  watch: {
    'forms' () {
    },
    'init' () {
      this.initialResults()
    },
    'result': {
      handler: async function () {
        this.output = await this.afterTreatment(this.result)
        this.$emit('change', this.output, this.$validator, this.errors)
      },
      deep: true
    }
  },
  created () {
    this.initialResults()
  },
  methods: {
    async initialResults () {
      let input = await this.preTreatment(this.init)
      let initials = {
        input: '',
        datalist: '',
        password: '',
        textarea: '',
        boolean: false,
        select: '',
        single: '',
        multiple: [],
        number: '',
        date: '',
        time: '',
        datetime: '',
        file: [],
        text: ''
      }
      this.result = this.forms.reduce((s, c) => ({ ...s, ...c.value ? { [c.value]: input[c.value] !== null && input[c.value] !== undefined ? input[c.value] : initials[c.type] } : {} }), {})
    },
    async preTreatment (init) {
      let input = {}
      for (let form of this.forms) {
        form.value && (input[form.value] = await (form.inputFormat || (async x => x))(init[form.value]))
      }
      return input
    },
    async afterTreatment (result) {
      let output = {}
      for (let form of this.forms) {
        form.value && (output[form.value] = await (form.outputFormat || (async x => x))(result[form.value]))
      }
      return output
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#custom-form-container
  width: 100%
  flex: 1
  // border: 1px solid #777777
  // padding: 10px
  &.flex
    display: flex
    flex-wrap: wrap
    align-items: stretch
    .form-group
      width: 0
  &.grid
    display: grid
    .form-group
      width: 100%
  &.small
    .form-group
      .label
        margin-bottom: 5px
        .title
          font-weight: 500
        .required
          display: none
      .options
        &.text
          span
            &.noWrap
              height: auto
  .form-group
    position: relative
    padding: 0
    &.disabled
      // opacity: 0.5
      .label
        & > *
          color: #999999 !important
    &.reading
      .label
        .title
          color: #003679
      .options
        &.text
          & > div
            span
    &.display-mode
      .label
        margin-bottom: 5px
    & > *:not(:last-child)
      margin-bottom: 2px
    .label
      margin-bottom: 7px
      white-space: nowrap
      overflow: hidden
      .title
        color: #003679
      .required
        color: #FA3D3D
        font-weight: bold
        margin-left: -2px
        // padding-left: 1px
      .description
        font-size: 0.8rem
      .invisible
        font-size: 0.8rem
        color: transparent
    .options
      position: relative
      z-index: 1
      &.error
        input, select, textarea
          border: 1px solid #FA3D3D
          background: white
      & > div
        padding: 0
        min-height: 34px
      &.input
        & > div
          // input[type="text"]
          //   width: 100%
          //   padding: 1px 2px
          //   box-sizing: border-box
      &.datalist
        & > div
          // input[type="text"]
          //   width: 100%
          //   padding: 1px 2px
          //   box-sizing: border-box
      &.password
        & > div
          // input[type="password"]
          //   width: 100%
          //   padding: 1px 2px
          //   box-sizing: border-box
      &.textarea
        & > div
          &.input-group
            height: auto
          textarea
            &::-webkit-resizer
              // border: 1px solid white
              // border-right: 1px solid transparent
              // border-bottom: 1px solid transparent
              background: url('../../assets/images/textarea-resizer.svg')
          // textarea
          //   width: 100%
          //   padding: 1px 2px
          //   box-sizing: border-box
          //   resize: vertical
      &.select
        & > div
          // select
          //  width: 100%
          //  padding: 2px 1px
      &.boolean
        & > div
          display: flex
          min-height: 18px
          label
            display: flex
            // width: 100%
            padding: 3px 0
            // &:hover
            //   background: #cccccc
            //   cursor: pointer
            input[type="checkbox"]
              margin-right: 5px
              padding: 1px 2px
      &.single
        & > div
          display: flex
          label
            display: flex
            align-items: center
            width: 100%
            padding: 3px
            &:hover
              // background: #cccccc
              cursor: pointer
            input[type="radio"]
              margin-right: 5px
              margin-top: 2px
              padding: 1px 2px
            span
              word-break: break-all
      &.multiple
        & > div
          display: flex
          label
            display: flex
            align-items: center
            width: 100%
            padding: 3px
            &:hover
              // background: #cccccc
              cursor: pointer
            // input[type="checkbox"]
            //   margin-right: 5px
            //   margin-top: 2px
            //   padding: 1px 2px
            img
              margin-right: 10px
            span
              word-break: break-all
      &.number
        & > div
          display: flex
          // input[type="number"]
          //   width: 100%
          //   padding: 1px 2px
      &.date
        & > div
          display: flex
          // input[type="date"]
          //   width: 100%
          //   padding: 1px 2px
      &.time
        & > div
          display: flex
          // input[type="time"]
          //   width: 100%
          //   padding: 1px 2px
      &.datetime
        & > div
          display: flex
          // input[type="datetime-local"]
          //   width: 100%
          //   padding: 1px 2px
      &.file
        width: 0
        & > div
          display: flex
          align-items: center
          button
            position: relative
            margin-right: 10px
            label
              position: absolute
              width: 100%
              height: 100%
              top: 0
              left: 0
              cursor: pointer
      &.text
        & > div
          height: auto
          min-height: 0
          padding-left: 0
          span
            width: 100%
            padding-right: 40px
            box-sizing: border-box
            white-space: pre-line
            &.noWrap
              white-space: nowrap
              overflow: hidden
              text-overflow: ellipsis
              padding-right: 0
              height: 41px
            &.failed
              color: #FF0000 !important
            &.top
              margin-bottom: 32px
      .error
        .menu-bor-cor
          &.shadow-top
            border-color: transparent transparent #FA3D3D !important
          &.shadow-left
            border-color: transparent transparent #FA3D3D !important
          &.shadow-right
            border-color: transparent transparent #FA3D3D !important
        .menu-block
          border: 1px solid #FA3D3D
          span
            color: #FA3D3D
      .success
        .menu-bor-cor
          &.shadow-top
            border-color: transparent transparent #83C91E !important
          &.shadow-left
            border-color: transparent transparent #83C91E !important
          &.shadow-right
            border-color: transparent transparent #83C91E !important
        .menu-block
          border: 1px solid #83C91E
          span
            color: #83C91E
      .error, .success
        position: absolute
        top: 10px
        right: 10px
        display: table !important
        img
          background: white
          &:hover
            & + div
              opacity: 1
              top: 32px
        .menu-container
          opacity: 1
          position: absolute
          right: -12px
          // top: -999999999999999px
          // opacity: 0
          opacity: 1
          top: 32px
          transition: opacity .5s ease
          z-index: 10
          &:hover
            opacity: 1
            top: 32px
          .cursor-bor-cor
            width: 50px
            height: 40px
            top: -40px
            right: 0
            position: absolute
          .menu-bor-cor
            z-index: 10
            width: 0
            height: 0
            font-size: 0
            border-width: 10px 5px
            border-style: solid
            border-color: transparent transparent white
            overflow: hidden
            position: absolute
            right: 15px
            top: -19px
            // cursor: pointer
            &.shadow-top
              top: -21px
            &.shadow-left
              right: 16px
            &.shadow-right
              right: 14px
          .menu-block
            padding: 5px 10px
            background: white
            box-sizing: border-box
            border-radius: 3px
            span
              white-space: nowrap
    .custom
      &.main-custom
        margin-bottom: 2px
      & > div > .label + div
        padding: 0
        min-height: 34px
</style>



// WEBPACK FOOTER //
// src/components/tool/customForm.vue